/**
 * Smooth accordion animation for <details>/<summary> elements.
 * Mimics Sporty & Rich style: height + padding slide, no opacity.
 * Easing: cubic-bezier(0.19, 1, 0.22, 1) - expo ease-out.
 *
 * Uses double-rAF for reliable transition start and setTimeout fallback
 * in case transitionend doesn't fire (e.g. display:none, 0-duration, etc.)
 */
(function () {
  var DURATION_MS = 400;
  var DURATION = DURATION_MS + 'ms';
  var EASING = 'cubic-bezier(0.19, 1, 0.22, 1)';
  var PROPS = 'height ' + DURATION + ' ' + EASING + ', padding ' + DURATION + ' ' + EASING + ', margin ' + DURATION + ' ' + EASING;

  function initAccordions() {
    var detailsList = document.querySelectorAll('.product-section-np .accordion details');
    detailsList.forEach(function (details) {
      if (details.dataset.animated) return;
      details.dataset.animated = 'true';

      var summary = details.querySelector('summary');
      var content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      var isAnimating = false;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (isAnimating) return;
        isAnimating = true;

        if (details.open) {
          closeAccordion(details, content, function () {
            isAnimating = false;
          });
        } else {
          openAccordion(details, content, function () {
            isAnimating = false;
          });
        }
      });
    });
  }

  /** Clean all inline animation styles from content element */
  function clearStyles(content) {
    content.style.transition = '';
    content.style.overflow = '';
    content.style.height = '';
    content.style.marginBottom = '';
    content.style.marginTop = '';
    content.style.paddingBottom = '';
    content.style.paddingTop = '';
  }

  /** Scroll the sticky info wrapper so the opened accordion summary is visible */
  function scrollToAccordion(details) {
    var wrapper = details.closest('.product__info-wrapper');
    if (wrapper) {
      var summary = details.querySelector('summary');
      if (summary) {
        // Calculate summary position relative to wrapper
        var summaryRect = summary.getBoundingClientRect();
        var wrapperRect = wrapper.getBoundingClientRect();
        var offset = summaryRect.top - wrapperRect.top + wrapper.scrollTop;
        wrapper.scrollTo({ top: Math.max(0, offset - 10), behavior: 'smooth' });
      }
    }
  }

  function closeAccordion(details, content, done) {
    var startHeight = content.offsetHeight;
    var cs = getComputedStyle(content);
    var mb = cs.marginBottom;
    var mt = cs.marginTop;
    var pb = cs.paddingBottom;
    var pt = cs.paddingTop;

    // Lock current dimensions
    content.style.overflow = 'hidden';
    content.style.height = startHeight + 'px';
    content.style.marginBottom = mb;
    content.style.marginTop = mt;
    content.style.paddingBottom = pb;
    content.style.paddingTop = pt;

    var cleaned = false;
    function finish() {
      if (cleaned) return;
      cleaned = true;
      content.style.display = 'none';
      clearStyles(content);
      details.open = false;
      content.style.display = '';
      done();
    }

    // Double-rAF ensures the browser has painted the locked dimensions
    // before starting the transition — prevents instant jump.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        content.style.transition = PROPS;
        content.style.height = '0';
        content.style.marginBottom = '0';
        content.style.marginTop = '0';
        content.style.paddingBottom = '0';
        content.style.paddingTop = '0';

        content.addEventListener('transitionend', function onEnd(e) {
          if (e.propertyName !== 'height') return;
          content.removeEventListener('transitionend', onEnd);
          finish();
        });

        // Fallback: if transitionend doesn't fire, finish after duration + buffer
        setTimeout(finish, DURATION_MS + 50);
      });
    });
  }

  function openAccordion(details, content, done) {
    // Pre-collapse content before opening
    content.style.overflow = 'hidden';
    content.style.height = '0';
    content.style.marginBottom = '0';
    content.style.marginTop = '0';
    content.style.paddingBottom = '0';
    content.style.paddingTop = '0';

    // Open details — content is in DOM but visually collapsed to 0
    details.open = true;

    // Measure natural dimensions
    content.style.height = '';
    content.style.marginBottom = '';
    content.style.marginTop = '';
    content.style.paddingBottom = '';
    content.style.paddingTop = '';

    var targetHeight = content.offsetHeight;
    var cs = getComputedStyle(content);
    var targetMb = cs.marginBottom;
    var targetMt = cs.marginTop;
    var targetPb = cs.paddingBottom;
    var targetPt = cs.paddingTop;

    // Re-collapse (same frame — no visual glitch)
    content.style.overflow = 'hidden';
    content.style.height = '0';
    content.style.marginBottom = '0';
    content.style.marginTop = '0';
    content.style.paddingBottom = '0';
    content.style.paddingTop = '0';

    var cleaned = false;
    function finish() {
      if (cleaned) return;
      cleaned = true;
      clearStyles(content);
      scrollToAccordion(details);
      done();
    }

    // Double-rAF: first rAF lets the browser commit the collapsed state,
    // second rAF triggers the actual transition.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        content.style.transition = PROPS;
        content.style.height = targetHeight + 'px';
        content.style.marginBottom = targetMb;
        content.style.marginTop = targetMt;
        content.style.paddingBottom = targetPb;
        content.style.paddingTop = targetPt;

        content.addEventListener('transitionend', function onEnd(e) {
          if (e.propertyName !== 'height') return;
          content.removeEventListener('transitionend', onEnd);
          finish();
        });

        // Fallback timeout in case transitionend doesn't fire
        setTimeout(finish, DURATION_MS + 50);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
})();
